import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { AgGridModule } from 'ag-grid-angular';
import { GridApi } from 'ag-grid-community';

import { PrismCardComponent } from '@shure/prism-angular-components';
import { AgGridAutoSizeContainerDirective } from '@shure/shared/angular/ui/components/ag-grid-next';

@Component({
	selector: 'sh-table-in-card',
	templateUrl: './table-in-card.component.html',
	styleUrls: ['./table-in-card.component.scss'],
	imports: [CommonModule, PrismCardComponent, AgGridModule, AgGridAutoSizeContainerDirective]
})
export class TableInCardComponent {
	/**
	 * Grid API instance for auto-sizing functionality.
	 * Pass the gridApi to enable automatic column sizing based on container width.
	 */
	public gridApi = input.required<GridApi | undefined>();

	/**
	 * CSS class to apply to the prism-card wrapper.
	 * Use this to apply custom styling or theme classes (e.g., 'ag-theme-balham-dark').
	 */
	public cardClass = input<string>('');

	/**
	 * Additional CSS classes to apply to the card for grid theming.
	 * Commonly used for ag-grid theme classes like 'ag-theme-balham-dark ag-theme-in-card ag-font-din'
	 */
	public gridThemeClass = input<string>('ag-theme-balham-dark ag-theme-in-card ag-font-din');
}
